<template>
  <div class="experienceMobile">
    <img src="https://cdn.youjiajk.com/yjExperienceBanner2.png"  style="width: 100%;" />
    <div class="tab">
      <div class="content">
        <div class="tabTitle">
          <span :class="currentIndex == 1 ? 'active' : ''" @click="currentChange(1)">家庭医生</span>
          <span :class="currentIndex == 2 ? 'active' : ''" @click="currentChange(2)">就医陪诊</span>
          <!-- <span :class="currentIndex == 3 ? 'active activeStyle' : ''" @click="currentChange(3)">门诊险</span> -->
        </div>
        <div class="tabCon content">
          <div v-if="currentIndex == 1" :class="['m-video', { hover: !originPlay }]"
            :style="`width: 100%; height: ${height}rem;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl1" width="100%" height="100%"
              :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}rem; height: ${playWidth}rem;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
          <div v-if="currentIndex == 2" :class="['m-video', { hover: !originPlay }]"
            :style="`width: 100%; height: ${height}rem;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl3"
              width="100%" height="100%" :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}px; height: ${playWidth}px;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
          <div v-if="currentIndex == 3" :class="['m-video', { hover: !originPlay }]"
            :style="`width: 100%; height: ${height}rem;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl2"
              width="100%" height="100%" :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}px; height: ${playWidth}px;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentIndex: 1,
        videoUrl1: 'https://cdn.youjiajk.com/家庭医生.m4v',
        videoUrl2: 'https://cdn.youjiajk.com/门诊险.mp4',
        videoUrl3: 'https://cdn.youjiajk.com/就医陪诊.m4v',
        autoplay: false,
        controls: true,
        loop: false,
        muted: false,
        preload: 'auto',
        playWidth: 0.96,
        zoom: 'fill',
        width: 7.5,
        height: 4.6,
        originPlay: true,
        vplay: true,
      }
    },
    methods:{
      currentChange(index) {
        this.currentIndex = index
      },
      clickPlay() {
        this.$refs.veo.play()
        this.vplay = false
        if (this.originPlay) {
          this.originPlay = false
        }
      }
    }
    
  }
</script>

<style lang="less" scoped>
  .experienceMobile{
    display: flex;
    flex-direction: column;
    .tab{
      padding: 0.8rem 0 0.73rem;
      background: #FBFCFE;
      .tabTitle{
        font-size: 0.26rem;
        font-family: Source Han Sans CN, Source Han Sans CN-6;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 0.39rem;
        padding-bottom: 0.23rem;
        border-bottom: 1px solid #e9ebed;
        text-align: center;
        margin-bottom: 0.37rem;
        span {
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 1.78rem;
          }

        }

        .active {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            bottom: -0.32rem;
            left: 0.07rem;
            border-bottom: 0.03rem solid #fd8246;
            width: 0.89rem;
          }
        }

        .activeStyle{
          &::after {
            width: 0.7rem;
          }
        }
      }
    }
    .tabCon{
      margin: 0 0.19rem;
    }
    .m-video {
      display: inline-block;
      position: relative;
      background: #000;

      .cursor {
        cursor: pointer;
      }

      .play {
        fill: none;
        color: #FFF;
        opacity: 0.7;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        transition: opacity .3s;

        &:hover {
          opacity: 0.9;
        }
      }

      .hidden {
        display: none;
      }
    }
    .hover {
      &:hover {
        .play {
          opacity: 0.9;
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/mobile/YJExperienceMobile.vue